import "./Block17BSetupFieldsPanelTable.css";

import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { Block17BSetupFieldsPanelHeader } from "./Block17BSetupFieldPanelHeader";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import { block17BSetupFieldsPanelInitialData } from "../../ROESetup";



let emptyBlock17BFields = {
  id: null,
  date: null,
  amount: null,
}

let columns = [
  { field: "date" },
  { field: "amount" },
];
interface IBlock17BSetupFieldsPanelTableFieldsTable {
  Block17BSetupFieldsPanelTableUpdatedData: (data: any) => void;
  Block17BSetupFieldsPanelTableDataItems: any;

  // selectedFieldPanelLabel:any;
}
export const Block17BSetupFieldsPanelTableFieldsTable: FC<
  IBlock17BSetupFieldsPanelTableFieldsTable
> = ({ Block17BSetupFieldsPanelTableUpdatedData, Block17BSetupFieldsPanelTableDataItems }) => {
  const [Block17BSetupFieldsPanelTable, setBlock17BSetupFieldsPanelTable] = useState<any>(
    Block17BSetupFieldsPanelTableDataItems
  );
  const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
  const [block17BSetupFields, setBlock17BFields] = useState(emptyBlock17BFields);

  useEffect(() => {
    setBlock17BSetupFieldsPanelTable(Block17BSetupFieldsPanelTableDataItems);
  }, [Block17BSetupFieldsPanelTableDataItems]);

  useEffect(() => {
    Block17BSetupFieldsPanelTableUpdatedData(Block17BSetupFieldsPanelTable);
  }, [Block17BSetupFieldsPanelTable]);


  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < Block17BSetupFieldsPanelTable.length; i++) {
      if (Block17BSetupFieldsPanelTable[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  //   const openNew = () => {
  //     // alert("new")
  //     if (Block17BSetupFieldsPanelTable && Block17BSetupFieldsPanelTable.length >= 10) return null;

  //     let _block17BSetupPanelData = [...Block17BSetupFieldsPanelTable];
  //     let _block17BSetupPanelNewRow: any = { ...block17BSetupFields };

  //     if (block17BSetupFields.id) {
  //       const index = findIndexById(block17BSetupFields.id);

  //       _block17BSetupPanelData[index] = _block17BSetupPanelNewRow;
  //     } else {
  //       // const newRowAdd = _block17BSetupPanelNewRow.id = createId();
  //       // _block17BSetupPanelData.push(_block17BSetupPanelNewRow);
  //       // setAddedRowId(newRowAdd)
  //       const newRowId  = createId();
  //       _block17BSetupPanelNewRow.id = newRowId ;
  //       _block17BSetupPanelData.push(_block17BSetupPanelNewRow);
  //       // setAddedRowId(newRowAdd);
  // //  setLastAddedRowId(newRowId );
  //     }
  //     setBlock17BSetupFieldsPanelTable(_block17BSetupPanelData);
  //     setBlock17BFields(emptyBlock17BFields);
  //   };

  const openNew = () => {


    if (Block17BSetupFieldsPanelTable && Block17BSetupFieldsPanelTable.length >= 10) return null;

    let _block17BSetupPanelData = [...Block17BSetupFieldsPanelTable];
    let _block17BSetupPanelNewRow: any = { ...block17BSetupFields };

    if (block17BSetupFields.id) {
      const rowIndex = findIndexById(block17BSetupFields.id);
      _block17BSetupPanelData[rowIndex] = _block17BSetupPanelNewRow;
    
    } else {
      const newRowId = createId();
      _block17BSetupPanelNewRow.id = newRowId;
      _block17BSetupPanelData.push(_block17BSetupPanelNewRow);
      setLastAddedRowId(newRowId && newRowId);
  
    }
    setBlock17BSetupFieldsPanelTable(_block17BSetupPanelData);
    setBlock17BFields(emptyBlock17BFields);
  };


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    setBlock17BSetupFieldsPanelTable((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };
  // const onDeleteNewAddedRow = () => {
  //   const updatedData = Block17BSetupFieldsPanelTable.filter(
  //     (row: any) => row.id !== addedRowId
  //   );
  //   setBlock17BSetupFieldsPanelTable(updatedData);
  //   setAddedRowId(null); // Clear the addedRowId after deletion
  // };

  const onDeleteNewAddedRow = (rowId: any) => {
    setBlock17BSetupFieldsPanelTable((prev: any[]) => {
      const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

      if (rowDeleteBasedOnId.length > 1) {
        const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
        setLastAddedRowId(lastRowId);
      } else {
        setLastAddedRowId(null);
      }
      return rowDeleteBasedOnId;
    });
  };

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "date") {
      if (
        rowData.Block17BSetupFieldsPanelTable !== "" &&
        rowData.Block17BSetupFieldsPanelTable !== undefined &&
        rowData.Block17BSetupFieldsPanelTable !== null
      ) {
        if (rowData.date === null) {
          return "p-component p-filled calender-error-input";
        } else if (rowData.date === "") {
          return "p-component p-filled calender-error-input";
        }
      }
    } else if (field.field === "statutoryHoliday") {
      if (
        rowData.date !== "" &&
        rowData.date !== undefined &&
        rowData.date !== null
      ) {
        if (rowData.Block17BSetupFieldsPanelTable === null) {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        } else if (rowData.Block17BSetupFieldsPanelTable === "") {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        }
      } else {
        return "p-component p-filled input-dropdown-fields .p-dropdown";
      }
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "date") {
      return (
        <Calendar
          id={"date"}
          value={rowData[x.field]}
          showIcon
          // className="calender"
          style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          showButtonBar
          className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
        />
      );
    }
    else if (x.field === "amount") {
      return (
        <InputNumber
          value={rowData[x.field]}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right", borderRadius: "2px" }}
        />
      );
    }

  };

  return (
    <>
      <div className="card">
        <Block17BSetupFieldsPanelHeader
          openNew={openNew}
        // selectedFieldPanelLabel={"Hello"}
        />
        <DataTable
          value={Block17BSetupFieldsPanelTable}
          // value={employeeStatus}
          dataKey="id"
          key={lastAddedRowId}
          showGridlines
          className="Block17BSetupFieldsPanelTable"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          scrollHeight="380px"
        >

          {columns.map((x: any, index: any) => {
            return (

              <Column
                key={index}
                field={x.field}
                columnKey={x.field}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}

          <Column
            body={(rowData: any, row: any) => {
              const showIcon = rowData.id === lastAddedRowId;
         
              return showIcon ? (
                <EnhancedButtonPrimeReact
                  icon="pi pi-times"
                  severity={EnhancedButtonPrimeReactSeverity.Danger}
                  className="p-button-rounded p-button-text shadow-none bg-transparent"
                  rounded
                  // onClickHandler={onDeleteNewAddedRow}
                  onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
                />
              ) : null;
            }}
          />
        </DataTable>
      </div>
    </>
  );
};
